import { UPDATE_NAVIGATION_REQUEST } from "../../actions";
const initialState = {
    data: null,
};
const navigationReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_NAVIGATION_REQUEST:
            return Object.assign(Object.assign({}, state), { data: action.payload });
        default:
            return state;
    }
};
export default navigationReducer;
